import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/git-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M439.6 236.1c4.7 4.7 8.5 13.8 8.5 20.4s-3.8 15.7-8.5 20.4l-194.7 194.7c-4.7 4.7-13.8 8.4-20.4 8.4s-15.7-3.8-20.4-8.4l-195.6-195.6c-4.7-4.7-8.5-13.8-8.5-20.4s3.8-15.7 8.5-20.4l134.1-134.1 50.8 50.8c-6 14.3-2.2 36.5 18.6 45v123c-22.3 9.1-28.8 38.4-11.3 56 5.6 5.5 16.4 10.1 24.3 10.1 7.8 0 18.7-4.5 24.3-10.1 13.2-13.1 16.2-42.5-9.1-55v-121.8l46.4 46.3c-14.2 34.5 29.5 63.8 56 37.3 25.7-25.7-1.2-68.5-35.5-56.7l-49.7-49.7c9.3-26.9-16.3-52.8-43.4-43.7l-51.5-51.5 40.7-40.6c4.7-4.7 13.8-8.4 20.4-8.4s15.7 3.8 20.4 8.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/git-alt.js
// module id = 848
// module chunks = 0